import { Link } from "@reach/router";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleSummaryData, OrderSummaryData } from "../../services/services";
import { getCookieData } from "../../Store/GetData";
import { Sessionstore } from "../../Store/StoreData";
import sample from "../../assets/images/ableaura.svg";
import * as classes from "./Grouporder.module.scss";
import { navigate } from "gatsby";
import { FailureModalShow } from "../../Store/Action/Action";
import moment from "moment";

export default function OrderSummary() {
  const dispatch = useDispatch();
  const userdata = useSelector((state) => state.data);
  const [uniqueOrderIds, setUniqueOrderIds] = useState(new Set());
  const [summaryData, setSummaryData] = useState();
  const [sportSub, setsportSub] = useState()
  console.log(window.location.pathname, "path")

  const handleOrderSummary = () => {
    OrderSummaryData()
      .then((res) => {
        const uniqueIds = new Set();
        const uniqueSummaryData = res.data.data.filter((ele) => {
          var itemid = ele?.summary?.id;
          const orderId = ele?.summary?.order_summary_id;
          const sports_sub = ele?.is_sport_subscription
          setsportSub(sports_sub)
          if (!uniqueIds.has(orderId)) {
            uniqueIds.add(orderId);
            return true;
          }
          return false;
        });
        setSummaryData(uniqueSummaryData);
        setUniqueOrderIds(uniqueIds);
      })
      .catch((err) => {
        dispatch(
          FailureModalShow({
            show: true,
            msg: err.message,
          })
        );
      });
  };

  useEffect(() => {
    handleOrderSummary();
  }, []);

  console.log(summaryData, "summaryData");

  return (
    <>
      {summaryData && summaryData.length !== 0 && sportSub !== 1 ? (
        <div className="mainsec">
          <div className={classes.ordercon}>
            {summaryData.filter(item => item.status !== 12).slice().reverse().map((ele) => (
              <div key={ele?.summary?.order_summary_id} className={classes.clubSec}>
                {/* <div className={classes.imgoutline}>
                <img aria-hidden="true" src={sample} alt="" role="image" />
              </div> */}
                {/* {ele?.is_trial_order === 1 ? (
                  <p className={`onlyDes ${classes.trial}`} >

                    Trial Booking
                  </p>
                )
                  : (
                    <p  >


                    </p>
                  )
                } */}
                {/* {ele?.is_sport_subscription === 1 && (
                  <p className={classes.subs} >
                    Subscription
                  </p>
                )} */}
                {ele?.is_trial_order === 1 && (
                  <p className={classes.trial} >
                    Trial Booking
                  </p>
                )}
                <h3 style={{ textAlign: "left" }} aria-level="1">{ele?.listing?.listing_service?.service_provider_name}</h3>

                {/* <p aria-level="1"> Summary ID: {ele?.summary?.order_summary_id}</p> */}
                {/* <p>Id: {ele.id}</p> */}
                <p role="none">
                  Order Date: {moment(ele?.summary?.created_at).format("DD-MM-YYYY")}
                </p>
                {ele?.is_trial_order !== 1 ? ( // Check if ele exists and is_trial_order is not equal to 1
                  <p className={classes.price}>Price: {ele?.summary?.total}</p> // Render price from ele.summary.total if condition is met
                ) : null}
                {/* {ele?.is_trial_order === 1 ?   (
                <p className={`onlyMob ${classes.trial}`} >

                  Trial Service
                </p>
              )
            : (
              <p className={`onlyMob ${classes.trial}`} >

               Paid Service
              </p>
            )
            } */}
                {/* {ele?.is_trial_order === 1 && (
                  <p>
                    A representative of the Able Aura tribe will get in touch with you very soon
                  </p>
                )} */}
                {ele?.is_trial_order !== 1 ? (

                  <div
                    className={`btnoutline ${classes.btn}`}
                    onClick={() => {
                      navigate("/myorders/list", {
                        state: { ...ele, isEdit: true },
                      });
                      //   navigate(`/Orders/detail/${ele.id}`, 
                      //   {
                      //     state: { ...ele, isEdit: true },
                      // });
                      // Sessionstore(
                      //   "viewData",
                      //   JSON.stringify({
                      //     id: ele.id,
                      //     listid: ele.summary?.id,
                      //   })
                      // );


                    }}
                    role="button"
                    tabIndex="0"
                  >
                    <div className={`SubmitBtn ${classes.SubmitBtn}`} tabIndex="0">
                      VIEW ORDER
                    </div>
                  </div>
                ) : ''}
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="mainsec">
          <div style={{ marginTop: "120px" }}>
            <p className={classes.noorder}>No orders found. Now's as good a time as any to give our services a try. </p>
            <Link style={{ textAlign: "center", fontSize: "21px" }} className={classes.learnmore} to="/academyathome">
              Explore &gt;
            </Link>
          </div>
        </div>
      )}
    </>
  );
}


